import { render, staticRenderFns } from "./ChatNavbar.vue?vue&type=template&id=4dbdd93c&"
import script from "./ChatNavbar.vue?vue&type=script&lang=js&"
export * from "./ChatNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dbdd93c')) {
      api.createRecord('4dbdd93c', component.options)
    } else {
      api.reload('4dbdd93c', component.options)
    }
    module.hot.accept("./ChatNavbar.vue?vue&type=template&id=4dbdd93c&", function () {
      api.rerender('4dbdd93c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/chat/ChatNavbar.vue"
export default component.exports